import script from "./HelpFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./HelpFile.vue?vue&type=script&lang=ts&setup=true"

import "./HelpFile.vue?vue&type=style&index=0&id=38502913&scoped=true&lang=less"
import "./HelpFile.vue?vue&type=style&index=1&id=38502913&lang=css"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38502913"]])

export default __exports__